<template>
  <div v-if="message" class="msg animate-fadeIn text-smart-red">
    {{ message }}
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  message: string | undefined;
}>();
</script>

<style lang="css" scoped>
@reference "tailwindcss";
@reference "tailwindcss/utilities";

@layer app {
  .msg {
    @apply absolute -bottom-4 font-medium px-2;
    color: var(--input-message-is-error);
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    left: 0;
    right: 0;
  }
}
</style>
